import type { NotificationTabCounts } from '../types/notification-tab-counts.type';
import type { NotificationTab } from '../types/notification-tab.type';
import type { TabConfig } from '../types/tab-config.type';
import type { NotificationTabsConfiguration } from './types/notification-tabs-configuration.type';

export const useNotificationTabsConfiguration = (
  counts: NotificationTabCounts,
  onChange: (tab: NotificationTab) => void
): NotificationTabsConfiguration => {
  const tabs: TabConfig[] = [
    { count: counts.all, key: 'all', label: 'All' },
    { count: counts.unread, key: 'unread', label: 'Unread' },
    { count: counts.errors, key: 'errors', label: 'Errors' },
  ];

  const onTabClick = (key: NotificationTab) => {
    onChange(key);
  };

  return { onTabClick, tabs };
};
